module.exports = __webpack_public_path__ + "static/img/inviteFriendsBoxBg.cbe14b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/inviteFriendsBoxBg.png
// module id = 8DuP
// module chunks = 0